import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const HeroSection = ({ titleKey, subtitleKey, breadcrumbItems }) => {
  const { t } = useLanguage();

  return (
    <section className="page-hero">
      <div className="container position-relative" style={{zIndex:1}}>
        {/* Breadcrumb */}
        {breadcrumbItems && (
          <nav className="breadcrumb-custom mb-3" aria-label="breadcrumb">
            {breadcrumbItems.map((item, idx) => (
              <span key={idx}>
                {idx > 0 && <span className="mx-1">/</span>}
                {item.path ? (
                  <Link to={item.path}>{t(item.key)}</Link>
                ) : (
                  <span>{t(item.key)}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className="page-hero-title anim-fade-up">{t(titleKey)}</h1>
        {subtitleKey && (
          <p className="page-hero-subtitle anim-fade-up anim-delay-1">{t(subtitleKey)}</p>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
